import AlarmPipeline from '@/models/dictionaries/AlarmPipeline'
import DeviceModel from '@/models/dictionaries/DeviceModel'
import DeviceProtocol from '@/models/dictionaries/DeviceProtocol'
import DeviceCommandType from '@/models/dictionaries/DeviceCommandType'
import DeviceCommandState from '@/models/dictionaries/DeviceCommandState'
import DeviceDataToCapture from '@/models/dictionaries/DeviceDataToCapture'
import Channel from '@/models/dictionaries/Channel'
import CameraPositionType from '@/models/dictionaries/CameraPositionType'
import DeviceHealthCheckType from '@/models/dictionaries/DeviceHealthCheckType'
import Language from '@/models/dictionaries/Language'
import SpeedUnitType from '@/models/dictionaries/SpeedUnitType'
import License from '@/models/dictionaries/License'
import FuelType from '@/models/dictionaries/FuelType'
import VehicleType from '@/models/dictionaries/VehicleType'
import EventType from '@/models/dictionaries/EventType'
import EventCategory from '@/models/dictionaries/EventCategory'
import EventClassification from '@/models/dictionaries/EventClassification'
import ThresholdLevel from '@/models/dictionaries/ThresholdLevel'
import TimelineBlockStatus from '@/models/dictionaries/TimelineBlockStatus'
import Role from '@/models/dictionaries/Role'
import TimeZone from '@/models/dictionaries/TimeZone'
import BrandImageType from '@/models/dictionaries/BrandImageType'

export const SET_DEVICE_MODELS = 'setDeviceModels'
export const SET_DEVICE_PROTOCOLS = 'setDeviceProtocols'
export const SET_DEVICE_COMMAND_TYPES = 'setDeviceCommandTypes'
export const SET_DEVICE_COMMAND_STATES = 'setDeviceCommandStates'
export const SET_DEVICE_DATA_TO_CAPTURE = 'setDeviceDataToCapture'
export const SET_CHANNELS = 'setChannels'
export const SET_CAMERA_POSITION_TYPES = 'setCameraPositionTypes'
export const SET_DEVICE_HEALTH_CHECK_TYPES = 'setDeviceHealthCheckTypes'
export const SET_VIDEO_STREAM_QUALITY_TYPES = 'setVideoStreamQualityTypes'
export const SET_SPEED_UNIT_TYPES = 'setSpeedUnitTypes'
export const SET_LANGUAGES = 'setLanguages'
export const SET_LICENSES = 'setLicenses'
export const SET_ROLES = 'setRoles'
export const SET_FUEL_TYPES = 'setFuelTypes'
export const SET_VEHICLE_TYPES = 'setVehicleTypes'
export const SET_EVENT_TYPES = 'setEventTypes'
export const SET_EVENT_CATEGORIES = 'setEventCategories'
export const SET_EVENT_CLASSIFICATIONS = 'setEventClassifications'
export const SET_THRESHOLD_LEVELS = 'setThresholdLevels'
export const SET_ALARM_PIPELINE = 'setAlarmPipeline'
export const SET_TIMELINE_BLOCK_STATUSES = 'setTimelineBlockStatuses'
export const SET_TIME_ZONES = 'setTimeZones'
export const SET_BRAND_IMAGE_TYPE = 'setBrandImageType'

const setDeviceModels = (state, deviceModels) => {
    const result = []
    for (const deviceModel of deviceModels) {
        result.push(new DeviceModel(deviceModel.id, deviceModel.key, deviceModel.availableChannels))
    }

    state.deviceModels = result
}

const setDeviceProtocols = (state, deviceProtocols) => {
    const result = []
    for (const deviceProtocol of deviceProtocols) {
        result.push(new DeviceProtocol(deviceProtocol.id, deviceProtocol.key))
    }

    state.deviceProtocols = result
}

const setDeviceCommandTypes = (state, deviceCommandTypes) => {
    const result = []
    for (const deviceCommandType of deviceCommandTypes) {
        result.push(new DeviceCommandType(deviceCommandType.id, deviceCommandType.key))
    }

    state.deviceCommandTypes = result
}

const setDeviceCommandStates = (state, deviceCommandStates) => {
    const result = []
    for (const deviceCommandState of deviceCommandStates) {
        result.push(new DeviceCommandState(deviceCommandState.id, deviceCommandState.key))
    }

    state.deviceCommandStates = result
}

const setDeviceDataToCapture = (state, deviceDataToCapture) => {
    const result = []
    for (const dataToCapture of deviceDataToCapture) {
        result.push(new DeviceDataToCapture(dataToCapture.id, dataToCapture.key))
    }

    state.deviceDataToCapture = result
}

const setChannels = (state, channels) => {
    const result = []
    for (const channel of channels) {
        result.push(new Channel(channel.id, channel.key))
    }

    state.channels = result
}

const setCameraPositionTypes = (state, cameraPositionTypes) => {
    const result = []
    for (const cameraPositionType of cameraPositionTypes) {
        result.push(new CameraPositionType(cameraPositionType.id, cameraPositionType.key))
    }

    state.cameraPositionType = result
}

const setDeviceHealthCheckTypes = (state, deviceHealthCheckTypes) => {
    const result = []
    for (const deviceHealthCheckType of deviceHealthCheckTypes) {
        result.push(new DeviceHealthCheckType(deviceHealthCheckType.id, deviceHealthCheckType.key))
    }

    state.deviceHealthCheckTypes = result
}

const setVideoStreamQualityTypes = (state, videoStreamQualityTypes) => {
    const result = []
    for (const videoStreamQualityType of videoStreamQualityTypes) {
        result.push(new DeviceHealthCheckType(videoStreamQualityType.id, videoStreamQualityType.key))
    }

    state.videoStreamQualityTypes = result
}

const setSpeedUnitTypes = (state, speedUnitTypes) => {
    const result = []
    for (const speedUnitType of speedUnitTypes) {
        result.push(new SpeedUnitType(speedUnitType.id, speedUnitType.key))
    }

    state.speedUnitTypes = result
}

const setLanguages = (state, languages) => {
    const result = []
    for (const language of languages) {
        result.push(new Language(language.id, language.key))
    }

    state.languages = result
}

const setLicenses = (state, licenses) => {
    const result = []
    for (const license of licenses) {
        result.push(new License(license.id, license.description, license.name))
    }

    state.licenses = result
}

const setRoles = (state, roles) => {
    const result = []
    for (const role of roles) {
        result.push(new Role(role.id, role.key))
    }

    state.roles = result
}

const setFuelTypes = (state, fuelTypes) => {
    const result = []
    for (const fuelType of fuelTypes) {
        result.push(new FuelType(fuelType.id, fuelType.key))
    }

    state.fuelTypes = result
}

const setVehicleTypes = (state, vehicleTypes) => {
    const result = []
    for (const vehicleType of vehicleTypes) {
        result.push(new VehicleType(vehicleType.id, vehicleType.key))
    }

    state.vehicleTypes = result
}

const setEventTypes = (state, eventTypes) => {
    const result = []
    for (const eventType of eventTypes) {
        result.push(new EventType(eventType.id, eventType.key, eventType.categoryId))
    }

    state.eventTypes = result
}

const setEventCategories = (state, eventCategories) => {
    const result = []
    for (const eventCategory of eventCategories) {
        result.push(new EventCategory(eventCategory.id, eventCategory.key))
    }

    state.eventCategories = result
}

const setEventClassifications = (state, eventClassifications) => {
    const result = []
    for (const eventClassification of eventClassifications) {
        result.push(new EventClassification(eventClassification.id, eventClassification.key))
    }

    state.eventClassifications = result
}

const setThresholdLevels = (state, thresholdLevels) => {
    const result = []
    for (const thresholdLevel of thresholdLevels) {
        result.push(new ThresholdLevel(thresholdLevel.id, thresholdLevel.key))
    }

    state.thresholdLevels = result
}

const setAlarmPipeline = (state, alarmPipelines) => {
    const result = []
    for (const alarmPipeline of alarmPipelines) {
        result.push(new AlarmPipeline(alarmPipeline.id, alarmPipeline.key))
    }

    state.alarmPipelines = result
}

const setTimelineBlockStatuses = (state, timelineBlockStatuses) => {
    const result = []
    for (const timelineBlockStatus of timelineBlockStatuses) {
        result.push(new TimelineBlockStatus(timelineBlockStatus.id, timelineBlockStatus.key))
    }

    state.timelineBlockStatuses = result
}

const setTimeZones = (state, timeZones) => {
    const result = []
    for (const timeZone of timeZones) {
        result.push(new TimeZone(timeZone.id, timeZone.key, timeZone.utcOffset))
    }

    state.timeZones = result
}

const setBrandImageType = (state, brandImageTypes) => {
    const result = []
    for (const brandImageType of brandImageTypes) {
        result.push(new BrandImageType(brandImageType.id, brandImageType.key))
    }

    state.brandImageTypes = result
}

export default {
    setDeviceModels,
    setDeviceProtocols,
    setDeviceCommandTypes,
    setDeviceCommandStates,
    setDeviceDataToCapture,
    setChannels,
    setCameraPositionTypes,
    setDeviceHealthCheckTypes,
    setVideoStreamQualityTypes,
    setSpeedUnitTypes,
    setLanguages,
    setLicenses,
    setRoles,
    setFuelTypes,
    setVehicleTypes,
    setEventTypes,
    setEventCategories,
    setEventClassifications,
    setThresholdLevels,
    setAlarmPipeline,
    setTimelineBlockStatuses,
    setTimeZones,
    setBrandImageType
}
